import { useLogin } from "@privy-io/react-auth";
import { useTranslation } from "react-i18next";
import { useRouter } from "@tanstack/react-router";
import { type JSX } from "react";
import { cn } from "@/utils/utils";

interface ILoginButtonProps {
  icon?: JSX.Element;
}
export default function LoginButton({ icon }: ILoginButtonProps) {
  const { t } = useTranslation();
  const router = useRouter();

  const { login } = useLogin({
    onComplete: () => {
      router.navigate({ to: router.state.location.pathname });
    },
  });

  function handleLogin() {
    login({ loginMethods: ["google", "wallet", "email"] });
  }

  return (
    <>
      <button
        onClick={handleLogin}
        className={cn(
          "font-bold py-2 px-4 rounded-3xl transition-all duration-300 ease-in-out hover:scale-105",
          icon
            ? "border border-green-600 text-green-600 hover:bg-green-800 hover:text-white hover:border-green-800" // outlined style
            : "bg-green-600 hover:bg-green-700 text-white w-[120px]" // filled style
        )}
      >
        {icon || t("navbar.login")}
      </button>
    </>
  );
}
